import Color from 'color';
import React from 'react';

import ColorPicker from '../../../../../ColorPicker';
import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsDrawerContext} from '../../MediaSettingsDrawerContextProvider';

const DEFAULT_COLOR = {
  r: Math.floor(0.2 * 255),
  g: Math.floor(0.2 * 255),
  b: Math.floor(0.3 * 255),
  a: 1,
}; // Default background color for Babylon Scene is 0.2, 0.2, 0.3, 1 on a scale of 0-1. This converts it to 0-255.

export const Object3DBackgroundColor = () => {
  const {updateConfig, config} = useMediaSettingsDrawerContext();
  const {r, g, b, a} = config.object3DBackgroundColor ?? DEFAULT_COLOR;
  const backgroundColor = `rgba(${r}, ${g}, ${b}, ${a})`;
  const setColor = (color: string) => {
    const chosenColor = Color(color);
    updateConfig({
      object3DBackgroundColor: {
        r: chosenColor.red(),
        g: chosenColor.green(),
        b: chosenColor.blue(),
        a: chosenColor.alpha(),
      },
    });
  };
  return (
    <div className="flex justify-between">
      <SettingTitle title="Background color" />
      <ColorPicker
        activeColor={backgroundColor}
        setColor={setColor}
        trigger="button"
      />
    </div>
  );
};
